import { OrderAtomProps } from "../OrderModal.types";
import { DownloadDetailsBtn } from "./DownloadDetailsBtn";

import styles from "../OrderModal.module.scss";

export const OrderFooter = ({ orderDetails }: OrderAtomProps) => {
  return (
    <div className={styles.orderModal__footer}>
      <DownloadDetailsBtn orderDetails={orderDetails} />
    </div>
  );
};
